import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IModalBase } from '../../interfaces/commonInterfaces'
import moment from 'moment'

export interface CustomerState {
  customerList?: unknown
  customerOptionList?: unknown
  customerDetail?: unknown
  reloadCustomerList?: string | null
  modalCustomer?: IModalBase
}

const initialState: CustomerState = {
  customerList: {},
  customerOptionList: {},
  customerDetail: {},
  reloadCustomerList: null,
  modalCustomer: {
    visible: false,
    record: {},
  },
}

export const customerDucks = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    getListCustomer: (state, action: PayloadAction<string | undefined>) => {
      state.customerList = { loading: true, queryStr: action.payload }
    },
    getListCustomerSuccess: (state, action: PayloadAction<unknown>) => {
      state.customerList = { loading: false, ...(action.payload as object) }
    },
    getListCustomerFail: (state, action: PayloadAction<unknown>) => {
      state.customerList = { loading: false, ...(action.payload as object) }
    },

    getListOptionCustomer: (state, action: PayloadAction<string | undefined>) => {
      state.customerOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionCustomerSuccess: (state, action: PayloadAction<unknown>) => {
      state.customerOptionList = { loading: false, ...(action.payload as object) }
    },
    getListOptionCustomerFail: (state, action: PayloadAction<unknown>) => {
      state.customerOptionList = { loading: false, ...(action.payload as object) }
    },

    getDetailCustomer: (state, action: PayloadAction<string | number>) => {
      state.customerDetail = { loading: true, id: action.payload }
    },
    getDetailCustomerSuccess: (state, action: PayloadAction<unknown>) => {
      state.customerDetail = { loading: false, ...(action.payload as object) }
    },
    getDetailCustomerFail: (state, action: PayloadAction<unknown>) => {
      state.customerDetail = { loading: false, ...(action.payload as object) }
    },

    setReloadCustomerList: (state) => {
      state.reloadCustomerList = String(moment())
    },
    setModalCustomer: (state, action: PayloadAction<IModalBase>) => {
      state.modalCustomer = action.payload
    },
  },
})

export const {
  getListCustomer,
  getListCustomerSuccess,
  getListCustomerFail,
  getListOptionCustomer,
  getListOptionCustomerSuccess,
  getListOptionCustomerFail,
  getDetailCustomer,
  getDetailCustomerSuccess,
  getDetailCustomerFail,
  setReloadCustomerList,
  setModalCustomer,
} = customerDucks.actions

export default customerDucks.reducer
